import React, { useEffect, useState } from 'react';
import { CELL_TYPE } from '@shared/components/table/DLTTableModel';
import { Box, Button, Chip, Dialog } from '@mui/material';
import DLTFTable from '@shared/components/table/DLTTableComponent';
import DepositsVerification from './DepositsVerification/DepositsVerification';
const columns = [
    {
        id: 'recieved',
        label: 'Revieved at',
        type: CELL_TYPE.DATE_TIME,
    },
    {
        id: 'amount',
        label: 'Amount',
        type: CELL_TYPE.ID
    },
    {
        id: 'currency',
        label: 'Currency',
    },
    {
        id: 'destiantion_wallet_code',
        label: 'Destination wallet',
        type: CELL_TYPE.ID
    },
    {
        id: 'source_wallet_code',
        label: 'Source wallet',
        type: CELL_TYPE.ID
    },
    {
        id: 'status',
        label: 'Status',
    },
    {
        id: 'action',
        label: 'Action',
    },
];
const mapDeposits = (deposits, callback) => {
    return deposits.map((deposit) => {
        var _a;
        return ({
            id: deposit.code,
            recieved: deposit.compliance_received_at,
            amount: deposit.compliance_amount,
            currency: deposit.currency_ticker,
            destiantion_wallet_code: deposit.deposit_address,
            source_wallet_code: ((_a = deposit.deposit_sources[0]) === null || _a === void 0 ? void 0 : _a.address) || 'N/A',
            status: React.createElement(Chip, { label: deposit.travel_rule_status }),
            action: (React.createElement(Button, { size: 'small', onClick: () => callback(deposit.code) }, "Verify")),
        });
    });
};
const DepositsToVerify = (props) => {
    const [depositsToRender, setDepositsToRender] = useState([]);
    const [selectedDeposit, setSelectedDepoist] = useState();
    const [showVerificationFlow, setShowVerificationFlow] = useState(false);
    useEffect(() => {
        setDepositsToRender(mapDeposits(props.deposits, handleVerifyAction));
    }, [props.deposits]);
    const handleVerifyAction = (code) => {
        const deposit = props.deposits.find((d) => d.code === code);
        setSelectedDepoist(deposit);
        setShowVerificationFlow(true);
    };
    const createVerificationComponent = () => {
        var _a;
        if (!selectedDeposit && !props.currentClient) {
            return;
        }
        return (React.createElement(DepositsVerification, { item: selectedDeposit, urlDeposits: props.urlDeposits, fetchDeposits: props.fetchDeposits, currentClient: (_a = props.currentClient) === null || _a === void 0 ? void 0 : _a.code, client: props.currentClient, toggle: () => setShowVerificationFlow(false), cellAction: () => { } }));
    };
    return (React.createElement(Box, { sx: { p: 2 } },
        React.createElement(DLTFTable, { columns: columns, data: depositsToRender, total: depositsToRender.length }),
        React.createElement(Dialog, { open: showVerificationFlow, maxWidth: 'sm', fullWidth: true },
            React.createElement(Box, { sx: { p: 2 } }, createVerificationComponent()))));
};
export default DepositsToVerify;
